import { render, staticRenderFns } from "./CreateCapacitations.vue?vue&type=template&id=7a737ceb&"
import script from "./CreateCapacitations.vue?vue&type=script&lang=js&"
export * from "./CreateCapacitations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports